<!--
    描述：用户管理页面
    时间：2020-04-22
    Created by yefan
-->
<template>
	<div class="h100">
		<w-split class="h100"
				 v-model="splitValue">
			<div class="w-page-main left"
				 slot="left">
				<div class="w-page-header">
					<div class="left-text overflow-hidden">
						<span><b>组织架构</b></span>
					</div>
					<div class="btnGroups ml10">
						<el-button type="primary"
								   size="small"
								   @click="addClick('addDept')"
								   v-if="roleBtns.includes('user_organize_add')">新增单位</el-button>
					</div>
				</div>
				<div class="w-page-container pdb10">
					<deptTreeTable ref="deptTreeTable"
								   @deptRowClick="deptRowClick"></deptTreeTable>
				</div>
			</div>
			<div class="w-page-main right"
				 slot="right">
				<div class="w-page-header">
					<search-area ref="searchContent"
								 v-model="searchForm.sname"
								 :showMore="false"
								 placeholderName="人员姓名"
								 @on-search="onSearch"
								 @on-refresh="onRefresh"
								 @on-reset="onReset">
					</search-area>
					<div class="btnGroups ml10">
						<el-button type="primary"
								   size="small"
								   @click="addClick('addUser')"
								   v-if="roleBtns.includes('user_add')">新增人员</el-button>
					</div>
				</div>
				<div class="w-page-container">
					<usersTable ref="userTable"
								:searchObj="searchForm"></usersTable>
				</div>
			</div>
		</w-split>
	</div>
</template>

<script>
import deptTreeTable from './components/dept_tree_table'
import usersTable from './components/users_table'
import { mapState } from 'vuex'

export default {
	name: 'User-management',
	components: { deptTreeTable, usersTable },
	data() {
		return {
			splitValue: 0.25,
			deptId: '',
			searchForm: {
				sname: ''
			},
			arr:[]
		}
	},
	methods: {
		//新增按钮点击事件
		addClick(type) {
			type === 'addDept'
				? this.$refs.deptTreeTable.doClick('addUnit', null)
				: this.$refs.userTable.doClick(null, 'add')
		},

		//左侧组织架构树单击行事件
		deptRowClick(row, tree) {
			let data = this.$utils.toTreeArray(tree)
			this.getIdArray(data, row.id)
			this.$refs.userTable.getUsers(this.arr)
			this.$refs.userTable.rowIds = this.arr
			this.$refs.userTable.deptId = row.id
			this.arr = []
			this.$refs.userTable.usersData.currentPage = 1
		},
		
        //获得展示部门id数组
		getIdArray(data, id) {
			this.arr.push(id)
			data.forEach(x => {
				if (x.parentId == id) {
					this.arr.push(x.id)
					this.getIdArray(data, x.id)
				}
			})
		},

		// 确认搜索
		onSearch() {
			this.deptIds = []
			// 清除树选中
			this.$refs.deptTreeTable.clearSelected()

			this.$refs.userTable.getUsers(this.deptIds)
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.deptId = ''
			this.searchForm.sname = ''

			// 清除树选中
			this.$refs.deptTreeTable.clearSelected()
		}
	},
	// 进入缓存页面
	activated() {
		this.splitValue = 0.25
	},
	computed: {
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	}
}
</script>

<style scoped lang="less">
</style>
